import React from 'react'
import PropTypes from 'prop-types'

const InfoCircleIcon = ({ customClassName, width, height, line, background, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Info Circle"
    viewBox="0 0 65 65"
  >
    <title id="info-circle-icon">Info Circle</title>
    <g>
      <ellipse fill={background} cx="32.5" cy="32.5" rx="29.5" ry="28.5" />
      <path
        fill={line}
        d="M32.5,0 C14.58,0 0,14.579 0,32.5 C0,50.421 14.58,65 32.5,65 C50.42,65 65,50.421 65,32.5 C65,14.579 50.42,0 32.5,0 Z M32.5,61 C16.785,61 4,48.215 4,32.5 C4,16.785 16.785,4 32.5,4 C48.215,4 61,16.785 61,32.5 C61,48.215 48.215,61 32.5,61 Z"
      />
      <circle fill={line} cx="32.018" cy="19.541" r="3.345" />
      <path
        fill={line}
        d="M32.137,28.342 C31.033,28.342 30.137,29.238 30.137,30.342 L30.137,47.342 C30.137,48.446 31.033,49.342 32.137,49.342 C33.241,49.342 34.137,48.446 34.137,47.342 L34.137,30.342 C34.137,29.237 33.241,28.342 32.137,28.342 Z"
      />
    </g>
  </svg>)

InfoCircleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  line: PropTypes.string,
  background: PropTypes.string,
  customClassName: PropTypes.string,
}

InfoCircleIcon.defaultProps = {
  width: 20,
  height: undefined,
  line: 'blue',
  background: 'white',
  customClassName: '',
}

export default InfoCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/InfoCircle.js